import Instruction from 'app/src/engine/instructions/Instruction';
import MoveInstructionSegment, {
	MoveInstructionSegmentType,
} from 'app/src/engine/instructions/MoveInstructionSegment';

export enum MoveInstructionType {
	Move1,
	Move2,
	Move3,
	BackUp,
}

export default class MoveInstruction extends Instruction {
	get basePriority(): number {
		return 100;
	}

	private _type: MoveInstructionType;
	get type(): MoveInstructionType {
		return this._type;
	}

	constructor(type: MoveInstructionType) {
		super();

		this._type = type;
		this.reset();
	}

	// Interactions need to be reset after being used.
	public reset(): void {
		// Create segments.
		switch (this._type) {
			case MoveInstructionType.Move1:
				this._remainingSegments = [
					new MoveInstructionSegment(MoveInstructionSegmentType.DriveForward),
				];
				break;

			case MoveInstructionType.Move2:
				this._remainingSegments = [
					new MoveInstructionSegment(MoveInstructionSegmentType.DriveForward),
					new MoveInstructionSegment(MoveInstructionSegmentType.DriveForward),
				];
				break;

			case MoveInstructionType.Move3:
				this._remainingSegments = [
					new MoveInstructionSegment(MoveInstructionSegmentType.DriveForward),
					new MoveInstructionSegment(MoveInstructionSegmentType.DriveForward),
					new MoveInstructionSegment(MoveInstructionSegmentType.DriveForward),
				];
				break;

			case MoveInstructionType.BackUp:
				this._remainingSegments = [
					new MoveInstructionSegment(MoveInstructionSegmentType.DriveBackward),
				];
				break;
		}
	}
}
